import { ScheduleMethod, SchedulePortalType } from '../enums';

export function toPortalLabel(type?: SchedulePortalType | ScheduleMethod) {
  if (!type) return '';
  switch (type) {
    case 'BLUE_YONDER':
      return 'Blue Yonder';
    case 'DSDLINK':
      return 'DSDLink';
    case 'LMCONNECT':
      return 'L&M Connect';
    case 'NCR':
      return 'NCR (Retalix)';
    default:
      return titleCase(type as string);
  }
}

export function isDatetimePickedByPortalAutomation(type?: SchedulePortalType) {
  return type == 'BLUE_YONDER';
}

function titleCase(str: string) {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
